import React, {useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FieldItem from "../field/FieldItem";
import styled from "styled-components";
import ActionBarForWidget from "../ActionBarForWidget";

const FieldItemsStyled = styled.div`
  display: grid;
  grid-gap: 10px;
`;

const FieldStyled = styled.div`
  margin-bottom: 10px;
  padding: 0 10px;
`;


const FieldsDialog = ({open, onClose, productsDetection, shelvesDetection, fields, indications,poseDetection}) => {
    const [fieldSize, s_fieldSize] = useState(400);
    const [hideFields, s_hideFields] = useState(false);

    const hasData = !!fields?.length;

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            fullScreen={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <ActionBarForWidget
                    titleIcon={"field"}
                    title={"Fields"}
                    showFullscreen={false}
                    onMinScreenClick={() => {
                        onClose();
                    }}
                    onPlusClick={() => {
                        s_fieldSize(fieldSize + 100);
                        s_hideFields(true);
                        setTimeout(() => {
                            s_hideFields(false);
                        }, 0);
                    }}
                    onMinusClick={() => {
                        s_fieldSize(fieldSize - 100);
                        s_hideFields(true);
                        setTimeout(() => {
                            s_hideFields(false);
                        }, 0);
                    }}
                />
                <FieldItemsStyled
                    style={{
                        gridTemplateColumns: `repeat(auto-fit, ${fieldSize}px)`
                    }}
                >
                    {!hideFields && hasData && fields.map((field) => {
                        return (
                            <FieldStyled
                                key={field._id}
                            >
                                <FieldItem
                                    fieldSize={fieldSize}
                                    field={field}
                                    productsDetection={productsDetection}
                                    shelvesDetection={shelvesDetection}
                                    indications={indications}
                                    poseDetection={poseDetection}
                                />
                            </FieldStyled>

                        );
                    })}
                </FieldItemsStyled>

            </DialogContent>
        </Dialog>);
};

export default FieldsDialog;